"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelTemplateCategory_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var LabelTemplateCategory_Factory = /** @class */ (function () {
    function LabelTemplateCategory_Factory() {
    }
    LabelTemplateCategory_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            IsSystemGenerated: model.IsSystemGenerated,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SystemDefaultKey: model.SystemDefaultKey,
        };
        return result;
    };
    LabelTemplateCategory_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            IsSystemGenerated: model.IsSystemGenerated,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SystemDefaultKey: model.SystemDefaultKey,
        };
        return result;
    };
    return LabelTemplateCategory_Factory;
}());
exports.LabelTemplateCategory_Factory = LabelTemplateCategory_Factory;
